import constants from '../../../Constants';
import interactionParserUtils from './InteractionParserUtils';

const drawingParser = {
    parse(interaction, language, defaultLanguage) {
        const prompt = interactionParserUtils.getPrompt(interaction, language, defaultLanguage);
        const allowOrientationOverride = interaction.getAttribute('inspera:allowOrientationOverride') === 'true';
        const maxHeight = Number.parseInt(interaction.getAttribute('maxHeight'), 10);
        const maxWidth = Number.parseInt(interaction.getAttribute('maxWidth'), 10);
        const interactionType = (interaction?.nodeType === 1) ? interaction.localName : null;
        const responseIdentifier = interaction.getAttribute('responseIdentifier');

        let canvasBackground = null;
        const objectElements = interaction.getElementsByTagName('object');
        for (let i = 0; i < objectElements.length; i++) {
            const obj = objectElements[i];
            const isBackground = obj.getAttribute('inspera:isbackground') === 'true';
            const jsonContentItemId = obj.getAttribute('inspera:jsonContentItemId');
            const contentItemId = obj.getAttribute('data-contentitemid');
            if (isBackground || (contentItemId && jsonContentItemId)) {
                if (contentItemId) {
                    canvasBackground = {
                        contentItemId: Number.parseInt(contentItemId, 10),
                        jsonContentItemId: jsonContentItemId ? Number.parseInt(jsonContentItemId, 10) : null,
                    };
                }
                break;
            }
        }

        const extraResponseDeclarations = [
            {
                baseType: 'file',
                cardinality: 'single',
                identifier: `${responseIdentifier}_jsonId`,
            },
            {
                baseType: 'string',
                cardinality: 'single',
                identifier: `${responseIdentifier}_fileName`,
            },
            {
                baseType: 'string',
                cardinality: 'single',
                identifier: `${responseIdentifier}_fileType`,
            },
            {
                baseType: 'string',
                cardinality: 'single',
                identifier: `${responseIdentifier}_fileSize`,
            },
            {
                baseType: 'string',
                cardinality: 'single',
                identifier: `${responseIdentifier}_drawingBase64`,
            },
            {
                baseType: 'string',
                cardinality: 'single',
                identifier: `${responseIdentifier}_jsonData`,
            },
            {
                baseType: 'boolean',
                cardinality: 'single',
                identifier: `${responseIdentifier}_pendingSync`,
            },
            {
                baseType: 'uri',
                cardinality: 'single',
                identifier: `${responseIdentifier}_fileURI`,
            },
            {
                baseType: 'uri',
                cardinality: 'single',
                identifier: `${responseIdentifier}_jsonDataURI`,
            },
        ];

        return {
            allowOrientationOverride: allowOrientationOverride || false,
            canvasBackground,
            extraResponseDeclarations,
            maxHeight: maxHeight || 1123,
            maxWidth: maxWidth || 794,
            prompt,
            responseIdentifier,
            type: constants.interactionType.DRAWING_INTERACTION,
            interactionType,
        };
    },
};

export default drawingParser;
